import api from './../api';
import request from "../utils/requestToJavaServer";

export function User_Patient_Update({ user, patient }: any) {
    return new Promise((resolve, reject) => {
        request.post(api.userApi.USER_PATIENT_UPDATE, { user, patient }).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function User_Doctor_Update({ user, doctor }: any) {
    return new Promise((resolve, reject) => {
        request.post(api.userApi.USER_DOCTOR_UPDATE, { user, doctor }).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function User_Developer_Update({ user, developer }: any) {
    return new Promise((resolve, reject) => {
        request.post(api.userApi.USER_DEVELOPER_UPDATE, { user, developer }).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function User_Admin_Update(user:any){
    return new Promise((resolve, reject) => {
        request.post(api.userApi.USER_ADMIN_UPDATE,  user ).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function User_Phone(formData: FormData) {
    return new Promise((resolve, reject) => {
        request.post(api.userApi.USER_PHONE, formData).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function User_Info() {
    return new Promise((resolve, reject) => {
        request.get(api.userApi.USER_INFO).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}

export function User_Doctor_Certify(formData: FormData) {
    return new Promise((resolve, reject) => {
        request.post(api.userApi.USER_DOCTOR_CERTIFY, formData).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}

export function User_Certain_Info({ id, role }: any) {
    return new Promise((resolve, reject) => {
        request.get(api.userApi.USER_CERTAIN_INFO, {
            params: {
                id, role
            }
        }).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}


export function User_Integral() {
    return new Promise((resolve, reject) => {
        request.get(api.userApi.USER_INTEGRAL).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function User_Doctor_List() {
    return new Promise((resolve, reject) => {
        request.get(api.userApi.USER_DOCTOR_LIST).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function User_Artificial(formData: FormData) {
    return new Promise((resolve, reject) => {
        request.post(api.userApi.USER_ARTIFICIAL, formData).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function User_WaitRequest() {
    return new Promise((resolve, reject) => {
        request.get(api.userApi.USER_WAITREQUEST).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function User_Request({ pageNum, pageSize }: any) {
    return new Promise((resolve, reject) => {
        request.get(api.userApi.USER_REQUEST, {
            params: { pageNum, pageSize }
        }).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function User_Cancel_Request(formData:FormData){
    return new Promise((resolve,reject)=>{
        request.post(api.userApi.USER_CANCEL_REQUEST,formData).then((res)=>{
            resolve(res);
        }).catch((err)=>{
            reject(err);
        })
    })
}
export function User_Request_Accept(formData: FormData) {
    return new Promise((resolve, reject) => {
        request.post(api.userApi.USER_REQUEST_ACCEPT, formData).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function User_Request_Reject(formData: FormData) {
    return new Promise((resolve, reject) => {
        request.post(api.userApi.USER_REQUEST_REJECT, formData).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function User_History({category, pageNum, pageSize }: any) {
    return new Promise((resolve, reject) => {
        request.get(api.userApi.USER_HISTORY, {
            params: {category, pageNum, pageSize }
        }).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
